import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { twMerge } from 'tailwind-merge';

import {
  useScrollLock,
  BaseButton,
  Input,
  handleListContinuation,
} from '@repo/common';

import {
  addQuestionAnswer,
  updateQuestionAnswer,
} from '../../../api/qna/qnaAnswer.api';

// 백엔드 QnaAnswer.content 컬럼 길이와 맞춘다
const ANSWER_MAX_LENGTH = 2000;

const FakePlaceholder = ({ children, className }) => (
  <span
    className={twMerge(
      'absolute z-50 text-text-placeholder pointer-events-none',
      className
    )}
  >
    {children}
  </span>
);

const AnswerModal = ({
  isOpen,
  onClose,
  qnaId,
  initialData,
  onAnswerUpdated,
}) => {
  const [answer, setAnswer] = useState(initialData?.content || '');

  useScrollLock(isOpen);

  if (!isOpen) return null;

  const handleSubmitClick = async () => {
    try {
      let updatedAnswer;
      if (initialData?.answerId) {
        updatedAnswer = await updateQuestionAnswer({
          answerId: initialData.answerId,
          content: answer,
        });
        updatedAnswer = {
          ...updatedAnswer,
          author: initialData.author,
          content: answer,
        };
      } else {
        updatedAnswer = await addQuestionAnswer({
          qnaId,
          content: answer,
        });
      }

      if (onAnswerUpdated) {
        onAnswerUpdated(updatedAnswer);
      }

      onClose();
    } catch (error) {
      console.error('Q&A 답변 등록/수정 실패:', error);
    }
  };

  return ReactDOM.createPortal(
    <div
      className='fixed inset-0 z-[1000000000] flex items-center justify-center bg-surface-black40'
      onClick={onClose}
    >
      {/* 모달 컨테이너 */}
      <div
        className='relative w-full max-w-[720px] bg-grayscale-gray01 rounded-[40px] animate-fadeIn'
        onClick={(e) => e.stopPropagation()}
      >
        {/* 헤더 영역 */}
        <div className='flex justify-between items-center px-6 pt-5 pb-4'>
          <div className='w-[120px] h-12'>
            <BaseButton
              onClick={() => {
                setAnswer('');
                onClose();
              }}
              type='text'
              size='xl'
              hideIcon
              textclass='text-green-deep03'
            >
              close
            </BaseButton>
          </div>

          <div className='typo-title2 text-text-primary'>Ask us? Anything!</div>

          <BaseButton
            size='l'
            isDisabled={!answer.trim()}
            hideIcon
            width='120px'
            onClick={handleSubmitClick}
          >
            Submit
          </BaseButton>
        </div>

        {/* 질문 입력 섹션 */}
        <div className='px-6 pb-10'>
          <div className='relative'>
            <Input
              as='textarea'
              label=''
              placeholder=''
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              // "- " / "1. " 로 시작한 줄에서 Enter 시 다음 항목을 이어 붙인다
              onKeyDown={(e) => handleListContinuation(e, setAnswer, ANSWER_MAX_LENGTH)}
              maxLength={ANSWER_MAX_LENGTH}
              // setAnswer.length 는 setter 함수의 인자 수(1)라 항상 true 였다
              forceActiveBorder={answer.length > 0}
              textareaMinHeight='379px'
              textareaRows={10}
            />
            {!answer && (
              <FakePlaceholder className={'left-5 top-[14px]'}>
                Add answer
              </FakePlaceholder>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AnswerModal;
